import React from "react";
import { MapConsumer, Marker, Popup } from "react-leaflet";
import { geDataFormat } from "../../../common/utils";
import DashboardMappatureService from "./dashboardMappatureService";


class HandlerMarker extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          visibleMarkers: [],
          detailMarker:""
        };

        this.dashboardMappatureService = new DashboardMappatureService();
    }
  
    componentDidMount() {
      const  map  = this.props.leaflet;
  
      if (map) {
        map.on('moveend', this.handleMapMoveEnd);
        this.handleMapMoveEnd();
      }
    }


    componentWillUnmount() {
      const map  = this.props.leaflet;


      if (map) {
        map.off('moveend', this.handleMapMoveEnd);
      }
    }

    handleMapMoveEnd = () => {
      const map  = this.props.leaflet;
      const bounds = map.getBounds();

      // Filtra i marker in base ai limiti della mappa
      const visibleMarkers = this.props.datiMarker.filter(
        (marker) => bounds.contains([marker.lat, marker.lng])
      );

      this.setState({ visibleMarkers:visibleMarkers });
    };
  
    render() {
      return (
              <>
                {this.state.visibleMarkers.map((marker,index) => (
                        <Marker key={index} position={[marker.lat, marker.lng]}>
                          <Popup
                            onOpen={() => {
                              // console.log("simone")
                              this.dashboardMappatureService.getDetailMarker(
                                marker.idSanzione,
                                (result) => {
                                  this.setState({ detailMarker: result.data });
                                }
                              );
                            }}
                          >
                            {this.state.detailMarker !== ""
                            ?
                            (<>
                            <h4 className="text-break">
                              <a
                                onClick={() => {
                                  sessionStorage.removeItem("rowSanzione");
                                  sessionStorage.setItem(
                                    "rowSanzione",
                                    JSON.stringify({id:marker.idSanzione,mappatura:true})
                                  );
                                  // sessionStorage.setItem(
                                  //   "filtriMappatura",
                                  //   JSON.stringify(this.state.filtro)
                                  // );
                                  this.props.push("/detailSanzione");
                                }}
                              >
                                {this.state.detailMarker.numeroSanzione}
                              </a>
                            </h4>
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th scope="col">Emissione</th>
                                  <th scope="col">Matricola</th>
                                  <th scope="col">Sato</th>
                                  <th scope="col">Importo</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {geDataFormat(
                                      this.state.detailMarker.dataSanzione
                                    )}
                                  </td>
                                  <td>{this.state.detailMarker.matricola}</td>
                                  <td>{this.state.detailMarker.statoSanzione}</td>
                                  <td>
                                    {parseFloat(
                                      this.state.detailMarker.importo / 100
                                    ).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            </>)
                            :<></>}
                          </Popup>
                        </Marker>
                ))}
              </>
      );
    }
  }

  export default HandlerMarker